export { ToolLandingPageHeaderTemplate } from './ToolLandingPageTemplate'
export type { ToolLandingPageHeaderTemplateProps } from './ToolLandingPageTemplate.types'
